import React from "react";
import BackgroundLayers from "../components/BackgroundLayers";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Features from "../components/Features";
import Stats from "../components/Stats";
import Testimonials from "../components/Testimonials";
import Marquee from "../components/Marquee";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div
      data-testid="qontri-landing-root"
      className="relative min-h-screen bg-[#F0EAFD] text-[#0F2C5A] overflow-x-hidden"
    >
      <BackgroundLayers />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Features />
        <Stats />
        <Testimonials />
        <Marquee />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
